export default __webpack_public_path__ + "static/media/Homepage Image-02.c749f2e4.png";